var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign1X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu-icon/campaign@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-icon/campaign",
    fill: "#3365FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.375,2 C15.7201875,2 16,2.28275789 16,2.63157895 L16,2.63157895 L16,13.3684211 C16,13.7172421 15.7201875,14 15.375,14 L15.375,14 L0.625,14 C0.2798125,14 0,13.7172421 0,13.3684211 L0,13.3684211 L0,2.63157895 C0,2.28275789 0.2798125,2 0.625,2 L0.625,2 Z M14.75,3.26315789 L1.25,3.26315789 L1.25,12.7368421 L14.75,12.7368421 L14.75,3.26315789 Z M6.32071841,5.1389993 C6.51917896,5.01381728 6.76369468,5.01381728 6.96215523,5.1389993 L6.96215523,5.1389993 L10.6792816,7.48340324 C10.8777421,7.60855023 11,7.83988998 11,8.09021899 C11,8.34054801 10.8777421,8.57188776 10.6792816,8.69703475 L10.6792816,8.69703475 L6.96215523,11.0414387 C6.76372675,11.1666207 6.51917896,11.1666557 6.32071841,11.0414387 C6.12225786,10.9162917 6,10.6849519 6,10.4346229 L6,10.4346229 L6,5.74581506 C6,5.495451 6.12225786,5.26414629 6.32071841,5.1389993 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign1X);
export default __webpack_public_path__ + "static/media/campaign1x.12b26fe895f0620c318b996d0c2a762c.svg";
export { ForwardRef as ReactComponent };